import { pulseContactRequests, pulseResponses } from '../pulse'
import { describeTable } from './describeTable'

describeTable(pulseResponses, {
  description: `Weekly employee mood survey (Viikkofiilis) answers, one row per worker per week. Deliberately anonymous: there is no user id, only respondent_key (an HMAC of user + week under a secret held outside the database), so the table cannot be joined back to a person — never try to de-anonymise it, and report only aggregates per team/week. team_id is the worker's team as of that week (join teams); is_subcontractor separates subcontractors from employees.
week_start is the Monday of the ISO week (a date). score is the headline mood 1–5; answers holds the five statement scores 1–5 and is empty until the worker completes the second step.`,
  columns: {
    weekStart: 'Monday of the answered week (date).',
    respondentKey:
      'Pseudonymous per-week key; cannot be resolved to a user. Do not attempt to.',
    teamId: 'Team at answering time; NULL if the worker had none.',
    isSubcontractor: 'true = subcontractor (alihankkija), false = employee.',
    score: 'Overall week feeling, 1 (bad) – 5 (great).',
    comment: 'Optional anonymous free text.',
    answers:
      "JSON {time, help, tools, safety, voice} each 1–5 (agreement with: I finished the day's work in the workday / I get help when I need it / I had the information and tools needed / I could work safely / I dare to say when something does not work). Empty object until the second step.",
  },
})

describeTable(pulseContactRequests, {
  description: `Opt-in request from a worker to talk to someone in person, made from the pulse survey. Named on purpose (user_id) and kept apart from the anonymous responses; do not join it to pulse_responses. handled_at set = management has followed up.`,
  columns: {
    contactRole:
      'Who they want to talk to: supervisor (esihenkilö), safety_rep (työsuojeluvaltuutettu), hr (HR-johtaja), ceo (toimitusjohtaja).',
    handledAt: 'When the request was handled; NULL = open.',
    weekStart: 'Week the request was made in (Monday).',
  },
})
